import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { validateConfig } from './lib/validate-config';
import { configureStore } from './store/configure-store';
import { log } from './store/thunks';

let context = window || {};

context.AlfredContentAccidentInsuranceApp = (function() {
    function boostrapApplication(config, boostrapElement) {
        const store = configureStore(config);
        const renderApp = AppComponent => {
            ReactDOM.render(
                <Provider store={store}>
                    <AppComponent config={config} />
                </Provider>,
                boostrapElement,
                () => validateConfig(config, (level, msg) => store.dispatch(log(level, msg)))
            );
        };

        renderApp(App);

        /* istanbul ignore next */
        if (process.env.NODE_ENV !== 'production') {
            if (module.hot) {
                module.hot.accept('./App', () => {
                    const NextApp = require('./App').default;

                    renderApp(NextApp);
                });
            }
        }
    }

    return boostrapApplication;
})();
